export const ADD_ACCOUNT = 'ADD_ACCOUNT';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_UPDATE_BANK_ACCOUNT = 'SET_UPDATE_BANK_ACCOUNT';
export const GET_BANK_ACCOUNT_BY_MERCHANT = 'GET_BANK_ACCOUNT_BY_MERCHANT';
export const UPDATE_BANK_ACCOUNT_BY_MERCHANT = 'UPDATE_BANK_ACCOUNT_BY_MERCHANT';
export const DELETE_BANK_ACCOUNT_BY_MERCHANT = 'DELETE_BANK_ACCOUNT_BY_MERCHANT';
export const SET_BANK_DELETE = 'SET_BANK_DELETE';
